import { Children } from 'react';
import { Check, GripVertical, Trash2 } from 'lucide-react';
import { SCHEDULED_CHORE_CADENCES } from '../lib/constants.js';
import { IconButton } from './ui.jsx';

export function TaskRow({ item, onToggle, onRemove, onCadenceChange, draggable = false }) {
  const details = [item.room, item.cadence, item.weekDay].filter(Boolean).join(' / ');
  return (
    <div
      className={draggable ? 'task-row draggable-task' : 'task-row'}
      draggable={draggable}
      onDragStart={(event) => event.dataTransfer.setData('text/plain', item.id)}
    >
      {draggable && <GripVertical className="drag-handle" size={16} aria-hidden="true" />}
      <button
        className={item.doneToday ? 'check-circle checked' : 'check-circle'}
        onClick={onToggle}
        type="button"
        aria-label={`Toggle ${item.title}`}
      >
        <Check size={14} />
      </button>
      <div className="task-content">
        <strong>{item.title}</strong>
        <span>{details ? `${details} / ` : ''}{item.streak} day streak</span>
        {item.cadence !== 'Daily' && onCadenceChange && (
          <select
            className="cadence-select"
            value={item.cadence}
            onChange={(event) => onCadenceChange(event.target.value)}
            aria-label={`${item.title} cadence`}
          >
            {SCHEDULED_CHORE_CADENCES.map((cadence) => (
              <option key={cadence} value={cadence}>{cadence}</option>
            ))}
          </select>
        )}
      </div>
      {onRemove && <IconButton label="Remove" icon={Trash2} onClick={onRemove} />}
    </div>
  );
}

export function ChoreDropZone({ title, children, onDropChore, variant }) {
  const hasChildren = Children.count(children) > 0;
  return (
    <section
      className={variant === 'daily' ? 'panel chore-drop-zone daily-drop-zone' : 'panel chore-drop-zone'}
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => {
        event.preventDefault();
        const id = event.dataTransfer.getData('text/plain');
        if (id) onDropChore(id);
      }}
    >
      <div className="section-heading">
        <h3>{title}</h3>
      </div>
      <div className="task-stack">
        {hasChildren ? children : <p className="empty-drop-text">Drop chore here</p>}
      </div>
    </section>
  );
}
